import React from 'react';
import { useLocation } from 'react-router-dom';
import { AssetGoogleReviewsTable } from '~/components/AssetGoogleReviewsTable/AssetGoogleReviewsTable';
import { AssetManagementTable } from '~/components/AssetMangementTable/AssetMangementTable';
import './AssetGoogleReview.css';
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs';
import Spacer from '~/components/Spacer/Spacer';
import { OwnerGroupRetentionCard } from '~/components/OwnerGroupRetentionCard/OwnerGroupRetentionCard';

export const AssetGoogleReview = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const ownerGroupId = queryParams.get('ownerGroupId') as string;
  const ownerGroupName = queryParams.get('ownerGroupName') as string;
  const isOwnerGroup = queryParams.get('isOwnerGroup') as string;

  const decodedOwnerName = decodeURIComponent(ownerGroupName);

  // Keep hooks above this point. If we don't have the query params we need, render nothing.
  if (!ownerGroupId) {
    return null;
  }

  return (
    <div className='container'>
      <Breadcrumbs />
      {isOwnerGroup === 'true' && (
        <>
          <OwnerGroupRetentionCard
            ownerGroupId={ownerGroupId}
            ownerGroupName={decodedOwnerName}
            className=''
          />
          <Spacer height={20} />
        </>
      )}
      {/* {isVCMorSuperAdmin && (
        <div className='tableHeader'>
          <button
            className={`btn-standard btn-secondary ${
              isActiveBuildings ? 'switchSelected' : 'defaultSwitch'
            }`}
            onClick={() => toggleBuildingActiveState(true)}
          >
            ACTIVE
          </button>
          <button
            className={`btn-standard btn-secondary  ${
              isActiveBuildings ? 'defaultSwitch' : 'switchSelected'
            }`}
            onClick={() => toggleBuildingActiveState(false)}
          >
            INACTIVE
          </button>
        </div>
      )} */}
      <AssetManagementTable
        ownerId={ownerGroupId}
        isFromOwnerGroup={isOwnerGroup === 'true'}
        heading={`${decodedOwnerName} | Overview`}
        showSearchHeader
      />
      <Spacer height={20} />
      <AssetGoogleReviewsTable
        heading={`${decodedOwnerName} | Google Reviews`}
        ownerId={ownerGroupId}
        isFromOwnerGroup={isOwnerGroup === 'true'}
      />
    </div>
  );
};
